export default __webpack_public_path__ + "static/media/top100-logo-p.62795019.png";